import React, {Component} from 'react'
import {Card} from 'antd'
import ReportBalance from './ReportBalance'
import TableBalance from './TableBalance'

class Balance extends Component {
  render() {
    return (
      <Card title="Reporte de balance">
        <ReportBalance />
        <br />
        <TableBalance />
      </Card>
    )
  }
}

export default Balance



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balance/index.js